var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlashActiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 23,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9289322,
    y: 10.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 2.473088 27.970562)",
    width: 14.1421356,
    height: 1.9997864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.0001068,
    y: 29.9289322,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -15.9116879 35.5857849)",
    width: 1.9997864,
    height: 14.1421356
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,4h-1C10.972168,4,2,12.972168,2,24s8.972168,20,20,20h1c1.6542969,0,3-1.3457031,3-3V7C26,5.3457031,24.6542969,4,23,4 z M24,41c0,0.5512695-0.4487305,1-1,1h-1c-9.925293,0-18-8.074707-18-18S12.074707,6,22,6h1c0.5512695,0,1,0.4487305,1,1V41z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashActiveMedium);
export default __webpack_public_path__ + "static/media/flash-active--medium.b1718061a15727d488a860ff00445775.svg";
export { ForwardRef as ReactComponent };